import styled from "styled-components";

export const DefaultToastImageBox = styled.div`
    color: ${({theme}) => theme.colors.brandPrimary};
    border: 2px solid ${({theme}) => theme.colors.brandPrimary};
    border-radius: 50%;
    margin-right: 8px;
    padding: 1rem;
`;
